<template>
  <b-card title="Por Creación">
    <b-link
        v-if="selectedYear"
        class="small mb-1 d-block"
        @click="backToYears"
    >
      ← Volver a años
    </b-link>
    <div class="pie-text text-center">
      <h2 class="font-weight-bolder">
        {{ total || 0 }}
      </h2>
      <span class="font-weight-bold">{{ selectedYear || 'Total' }}</span>
    </div>
    <app-echart-doughnut
        @click="handleClick"
        :series="series"
        :show-legend="showLegend"
    />
  </b-card>
</template>

<script>
import { BCard, BLink } from 'bootstrap-vue';
import { mapGetters } from 'vuex';
import Vue from 'vue';

import AppEchartDoughnut from '@core/components/charts/echart/AppEchartDoughnut';
import { ioExpedientesSearchPost } from '@/febos/servicios/api/busqueda.api';

const meses = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre'
];
export default {
  name: 'DonutsFilesByCreationState',
  components: {
    BCard,
    BLink,
    AppEchartDoughnut
  },
  data() {
    return {
      total: 0,
      showLegend: true,
      selectedYear: null,
      isMultiYear: false,
      buckets: [],
      series: []
    };
  },
  methods: {
    buildYearSeries(buckets) {
      const byYear = {};
      buckets.forEach((b) => {
        const year = b.keyAsString.split('-')[0];
        byYear[year] = (byYear[year] || 0) + b.docCount;
      });
      return [
        {
          name: 'Año',
          type: 'pie',
          radius: ['50%', '70%'],
          label: { show: true, position: 'inner', fontSize: 12 },
          labelLine: { show: false },
          data: Object.entries(byYear).map(([year, value]) => ({ name: year, value }))
        }
      ];
    },
    buildMonthSeries(buckets, year) {
      const filtered = year
        ? buckets.filter((b) => b.keyAsString.startsWith(year))
        : buckets;
      return [
        {
          name: 'Cantidad',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: false,
          label: { show: false },
          labelLine: { show: false },
          data: filtered.map((b) => {
            const [y, month] = b.keyAsString.split('-');
            const mes = meses[parseInt(month, 10) - 1];
            return { name: mes, value: b.docCount, moth: month, _year: y, mes };
          })
        }
      ];
    },
    renderChart() {
      if (this.isMultiYear && !this.selectedYear) {
        this.showLegend = false;
        this.total = this.buckets.reduce((acc, b) => acc + b.docCount, 0);
        this.series = this.buildYearSeries(this.buckets);
      } else {
        this.showLegend = true;
        const filtered = this.selectedYear
          ? this.buckets.filter((b) => b.keyAsString.startsWith(this.selectedYear))
          : this.buckets;
        this.total = filtered.reduce((acc, b) => acc + b.docCount, 0);
        this.series = this.buildMonthSeries(this.buckets, this.selectedYear);
      }
    },
    backToYears() {
      this.selectedYear = null;
      this.renderChart();
    },
    async loadIndicator(filter) {
      const { data: { data } } = await ioExpedientesSearchPost({
        params: { filtros: filter },
        body: {
          size: 0,
          aggs: {
            porMes: {
              date_histogram: {
                field: 'fechaCreacion',
                calendar_interval: 'month',
                format: 'yyyy-MM'
              }
            }
          }
        }
      });
      this.buckets = data.aggregations.porMes.buckets || [];
      this.selectedYear = null;
      const years = new Set(this.buckets.map((b) => b.keyAsString.split('-')[0]));
      this.isMultiYear = years.size > 1;
      this.renderChart();
    },
    handleClick({ data }) {
      if (this.isMultiYear && !this.selectedYear) {
        this.selectedYear = data.name;
        this.renderChart();
        return;
      }
      const year = data._year;
      const month = data.moth;
      const date = Vue.moment().year(year).month(parseInt(month, 10) - 1);
      const startOfMonth = date.startOf('month').format('YYYY-MM-DD');
      const endOfMonth = date.endOf('month').format('YYYY-MM-DD');
      this.$emit('selected-card', {
        id: `${this.id}-${data.name}`,
        filters: `fechaCreacion:${startOfMonth}--${endOfMonth}`
      });
    }
  },
  computed: {
    ...mapGetters('Dnts', [
      'pagination'
    ])
  }
};
</script>

<style lang="scss">
.card-body {
  position: relative;

  .pie-text {
    width: 105px;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 44%;
    bottom: 0;
  }
}
</style>
